"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceContextState = void 0;
var services_1 = require("../services");
var user_preferences_services_1 = require("../services/user-preferences.services");
/**
 * It defines the service context state and provides convenient methods to obtain services.
 * This context is used to use/provide the services to components.
 *
 * @author javier.perez
 */
var ServiceContextState = /** @class */ (function () {
    function ServiceContextState(state) {
        if (state === void 0) { state = {}; }
        Object.assign(this, state);
    }
    ServiceContextState.newInstance = function (options) {
        var authService = services_1.AuthService.newInstance(options);
        options.retryOptionsOnNonAuthorized = authService.retryOptionsOnNonAuthorized();
        return new ServiceContextState({
            assessmentService: services_1.AssessmentService.newInstance(options),
            avrReportsService: services_1.AvrReportsService.newInstance(options),
            avrStandardReportsService: services_1.AVRStandardReportsService.newInstance(options),
            attemptService: services_1.AttemptService.newInstance(options),
            classService: services_1.ClassService.newInstance(options),
            userService: services_1.UserService.newInstance(options),
            learnosityService: services_1.LearnosityService.newInstance(options),
            curriculumService: services_1.CurriculumService.newInstance(options),
            assessmentTemplateService: services_1.AssessmentTemplateService.newInstance(options),
            assessmentTemplateSearchService: services_1.AssessmentTemplateSearchService.newInstance(options),
            analyticsService: services_1.AnalyticsService.newInstance(options),
            summaryService: services_1.SummaryService.newInstance(options),
            performanceBandService: new services_1.PerformanceBandService(),
            settingService: services_1.SettingService.newInstance(options),
            standardService: services_1.StandardService.newInstance(options),
            authService: authService,
            classPerformanceService: services_1.ClassPerformanceService.newInstance(options),
            assigneePerformanceService: services_1.AssigneePerformanceService.newInstance(options),
            itemQuestionPerformanceService: services_1.ItemQuestionPerformanceService.newInstance(options),
            assessmentPerformanceService: services_1.AssessmentPerformanceService.newInstance(options),
            standardSetService: new services_1.StandardSetService(),
            multipleAssessmentsPerformanceService: services_1.MultipleAssessmentsPerformanceService.newInstance(options),
            configurationService: services_1.ConfigurationService.newInstance(options),
            assessmentTemplateUsageService: services_1.AssessmentTemplateUsageService.newInstance(options),
            questionRubricService: services_1.QuestionRubricService.newInstance(options),
            announcementService: new services_1.AnnouncementService(),
            recommendationsService: services_1.RecommendationsService.newInstance(options),
            foundationalService: services_1.FoundationalService.newInstance(options),
            userLevelSettingsService: services_1.UserLevelSettingsService.newInstance(options),
            userAssignmentService: services_1.UserAssignmentService.newInstance(options),
            rubricRatingService: services_1.RubricRatingService.newInstance(options),
            reportFilesService: services_1.ReportFilesService.newInstance(options),
            schoolService: services_1.SchoolService.newInstance(options),
            adminSearchService: services_1.AdminSearchService.newInstance(options),
            assigneeUsageService: services_1.AssigneeUsageService.newInstance(options),
            standardHierarchyLevelService: new services_1.StandardHierarchyLevelService(),
            schoolYearService: services_1.SchoolYearService.newInstance(options),
            ltiAgsService: services_1.LtiAgsService.newInstance(options),
            userPreferencesService: new user_preferences_services_1.UserPreferencesService(),
            customRubricService: services_1.CustomRubricService.newInstance(options),
        });
    };
    return ServiceContextState;
}());
exports.ServiceContextState = ServiceContextState;
